import styles from '../Confirmation.module.scss'
import { Heading } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import { CldImage } from 'next-cloudinary'
import { ConfirmationProps } from '../types'
import ConfirmationWrapper from './ConfirmationWrapper'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'

const ConfirmationMailView = ({ producer }: ConfirmationProps) => {
  // i18n
  const { t } = useTranslation('registration')

  // Next router
  const { locale } = useRouter()

  return (
    <ConfirmationWrapper>
      <section className={styles['confirmation-card']}>
        <div className={styles.text}>
          <Heading as="h2" variant="h3" serif className="mb-400">
            {t(`confirmation.boltPropositions.title.confirmationEmail`)}
          </Heading>

          <Link representation="button" href={routes(locale).home}>
            {t(`confirmation.boltPropositions.backToHome`)}
          </Link>
        </div>

        {producer?.images?.profile?.url && (
          <div className={styles.image}>
            <CldImage fill src={producer.images.profile?.url} alt={producer.name[locale]} />
          </div>
        )}
      </section>
    </ConfirmationWrapper>
  )
}

export default ConfirmationMailView
